/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  gameInfoStyle,
  gameTimeStyle,
  gameInfoInlineRowStyle,
  gameInfoBulletStyle,
} from '../styles'

export interface GameInfoProps {
  isGameTimeToBeDefined: boolean
  gameDateWithoutTime: string | null
  gameTime: string
  leagueName: string
  arenaName: string
  facilityNumber: string
}

const GameInfo: React.FC<GameInfoProps> = ({
  isGameTimeToBeDefined,
  gameDateWithoutTime,
  gameTime,
  leagueName,
  arenaName,
  facilityNumber,
}) => {
  const parts = [leagueName, arenaName, facilityNumber].filter(
    (part): part is string => !!part && part.trim().length > 0
  )

  return (
    <div css={gameInfoStyle}>
      {isGameTimeToBeDefined ? (
        gameDateWithoutTime ? (
          <p css={gameTimeStyle}>TBD - {gameDateWithoutTime}</p>
        ) : null
      ) : (
        <p css={gameTimeStyle}>{gameTime}</p>
      )}
      {parts.length > 0 ? (
        <div css={gameInfoInlineRowStyle}>
          {parts.map((part, idx) => (
            <React.Fragment key={`${idx}-${part}`}>
              {idx > 0 ? <span css={gameInfoBulletStyle}>•</span> : null}
              <span>{part}</span>
            </React.Fragment>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default React.memo(GameInfo)
